// extracted by mini-css-extract-plugin
module.exports = {"tag":"ProductTag_tag__3bfp6"};